const $cache = {
    document: $(document),
    helpAreaModal: $("#help-area-modal")
};

const cartUtil = require("../components/cartUtil");

/**
 *  Help modal trigger event
 */
const helpPopupTrigger = () => {
    $cache.document.on("click", ".js-help-popup-trigger", () => {
        if ($cache.helpAreaModal.find(".content-asset").length) {
            $cache.helpAreaModal.modal("show");
            cartUtil.updateCartSummaryModalClass(true);
        } else {
            const helpPageUrl = document.querySelector(".js-help-page-url").getAttribute("data-url");
            window.location.href = helpPageUrl;
        }
    });
};

/**
 *  Init Help modal events
 */
const initModalHelp = () => {
    helpPopupTrigger();
};

export { initModalHelp };
